export enum SEGMENT {
    CONTROLED = "CONTROLED",
    VARIANT = "VARIANT",
}